
$(document).ready(function() {
  var winW = $(window).width();

  // Header
  var barraH = $('.barra').outerHeight();
  var infoH = $('.infobar').outerHeight();
  var headerH = $('header').outerHeight();

  $(window).load(function() {
    var barraH = $('.barra').outerHeight();
    var infoH = $('.infobar').outerHeight();
    var headerH = $('header').outerHeight();
  });

  if ( winW > 830 ) {
    if ($('body').hasClass('template-index')) {
      $('body').css('padding-top', barraH);
    } else {
      $('body').css('padding-top', barraH + headerH);
    }
    $('header').css('top', barraH);
    $(window).scroll(function() {
      if ($(window).scrollTop() > barraH) {
        $('header').addClass('fix');
        $('header').css('top', 0);
      } else {
        $('header').removeClass('fix');
        $('header').css('top', barraH);
      }
    });
  } else {
    $('body').css('padding-top', barraH + headerH) ;
    $('header').css('top', barraH);
    console.log("header", headerH)
    $(window).scroll(function() {
      if ($(window).scrollTop() > barraH) {
        $('header').addClass('fix');
        $('header').css('top', 0);
      } else {
        $('header').removeClass('fix');
        $('header').css('top', barraH);
      }
    });
  }

  $('header .icons li .search').click(function() {
    $('header .big-search').toggleClass('show');
    $('header .black-search').toggleClass('show');
  });

  $('header .big-search .cerrar-big-search').click(function() {
    $('header .big-search').toggleClass('show');
    $('header .black-search').toggleClass('show');
  });

  $('header .icons li .cart').click(function() {
    $('#minicart').addClass('show');
  });

  $('#minicart .cerrar').click(function() {
    $('#minicart').removeClass('show');
  });

  $('header .show-menu').click(function() {
    $('nav').addClass('show');
  });

  $('header nav .cerrar').click(function() {
    $('nav').removeClass('show');
  });

  // Home

  $('.pop-video .close').click(function(){
    $('.pop-video').removeClass('show');
  });

  // Product
  $('#main-photo ul').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '#mini-photos ul'
  });

  $('#mini-photos ul').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    vertical: true,
    asNavFor: '#main-photo ul',
    dots: false,
    arrows: false,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 830,
        settings: {
          vertical: true,
        }
      }
    ]
  });

  $('.product .deon > h3').each(function() {
    $(this).addClass('accor');
    $(this).nextUntil('h3').wrapAll('<div class="hide-info"></div>')
  });

  $('.product .deon h3').click(function() {
    $(this).toggleClass('active');
    $(this).next('.hide-info').toggleClass('show');
  });

  $('.product .tabsContainer .tabWrapper .tabContent.cont-info > h3').each(function() {
    $(this).addClass('title-description');
    $(this).nextUntil('h3').wrapAll('<div class="description-info"></div>')
  });

  $('.product .description-bottom > h3').each(function() {
    $(this).addClass('hide-title');
    $(this).nextUntil('h3').wrapAll('<div class="hide-description"></div>')
  });

  // Interioristas
  $('.pro-int .gallery ul').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true
  });

  $('.pro-int .ver').click(function() {
    $('.pro-int .gallery').addClass('show');
  });

  $('.pro-int .gallery .cerrar').click(function() {
    $('.pro-int .gallery').removeClass('show');
  });

  $('.product .des-int .inner > h3').each(function() {
    $(this).addClass('h3-int');
    $(this).nextUntil('h3').wrapAll('<div class="contacto"></div>')
  });

  $('.pro-int .contactar').click(function() {
    $('.pro-int .form').addClass('show');
  });

  $('.pro-int .form .cerrar').click(function() {
    $('.pro-int .form').removeClass('show');
  });

  // Shop The Look
  $('.pro-shop #gallery ul').slick({
    //infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    centerMode: true
  });

  $('.featured-collection ul .item[data-id="6650297680064"]').remove();
  $('.featured-collection ul .item[data-id="6652373205184"]').remove();

  // Pop Up
  $('#popup .cerrar').click(function() {
    $('#popup').removeClass('show');
  });

  if ( winW < 830 ) {
    $('nav ul.menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
    $('nav ul.menu > li.site-nav--has-dropdown span.down').click(function(){
      $(this).toggleClass('active');
      $(this).parent().siblings().children('.sub-menu').removeClass('show');
      $(this).parent().children('.sub-menu').toggleClass('show');
    });
    $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown').prepend('<span class="down"><i>+</i></span>');
    $('nav ul.menu > li > ul.sub-menu > li.site-nav--has-dropdown span.down').click(function(){
      $(this).toggleClass('active');
      $(this).parent().siblings().children('.sub-sub-menu').removeClass('show');
      $(this).parent().children('.sub-sub-menu').toggleClass('show');
    });
  }

  /**
   * Escucha permanente para agregar productos, funciona para snippet
   * product-item.liquid
   *
   * @param object this  Contiene el objeto del elemento cliqueado.
   */
  $('body').on('click', '.item .addcart', function() {
    var proVar = $(this).data('product-id');
    jQuery.ajax({
      type: "POST",
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: proVar
      },
      success: function(data) {
      },
      error: function(data) {
        if (data.status == 422) {
          $('.item-' + proVar + ' .alertas').text('Sin stock disponible');
        }
      },
      async: false
    });
    update_mini_cart(true);
  });
});

/**
 * Escucha permanente para borrar producto del mini carro
 *
 * @param object this  Contiene el objeto del elemento cliqueado.
 */
$('body').on('click', '#minicart .middle .left i.delete-prod', function() {
  var var_this = this;
  Shopify.removeItem($(this).data('id'), function() {
    $(var_this).css("margin", "0").parent().parent().slideUp(200);
    update_mini_cart(false, false);
  });
});

/**
 * Actualiza el mini carro
 *
 * @param boolean show  Muestra el menu
 * @param boolean all   Actualiza el sector medio del mini carro
 */
function update_mini_cart(show = false, all = true) {
  if (all) {
    $('#minicart .middle ul').empty();
  }
  $("#minicart .cifra").empty();
  jQuery.get("/cart.js", function(data) {
    for (var i = 0; i < data.items.length; i++) {
      var titulo     = data.items[i]["title"];
      var varianteID = data.items[i]["variant_id"];
      var precio     = data.items[i]["price"] ? parseFloat(data.items[i]["price"]).toString().substring(0, parseFloat(data.items[i]["price"]).toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
      var cantidad   = data.items[i]["quantity"];
      var imagen     = data.items[i]["image"];
      var proMini    = "<li><div class='left'><i class='delete-prod' data-id='" + varianteID + "'></i><h4>" + titulo + "</h4><h5>$" + precio + "</h5><h6>Quantity: <span>" + cantidad + "</span></h6></div><div class='right'><img src='" + imagen + "' alt='' /></div></li>";
      if (all) {
        $("#minicart .middle ul").append(proMini);
      }
    }
    var total     = data.total_price ? data.total_price.toString().substring(0, data.total_price.toString().length - 2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1.") : '0';
    var itemcount = data.item_count;
    $("#minicart .cifra").append('$' + total);
    $("header .icons li a.cart .count").html(itemcount);
    if (show) {
      $('#minicart').addClass('show');
    }
  }, 'json');
}

/**
 * Si en algún momento hay errores de carga de jQuery.
 * Uso: defer(function () { //= acá va la funcion =// });
 *
 * @param object method  Funcion completa a ejecutar
 */
function defer(method) {
  if (window.jQuery) {
    method();
  } else {
    setTimeout(function() { defer(method) }, 50);
  }
}
